module.exports = __webpack_public_path__ + "img/yt-slp_eth_usdc-usdc.a9650134.png";